import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import Button from '@paradigm/design-system/src/components/Button';

const ToggleButton = styled(Button).attrs((props: { active?: boolean }) => ({
  ...props,
  size: 'large',
  variant: 'squared',
  theme: props.active === true ? 'secondary-light-blue' : 'primary-dark',
  bold: true,
  fluid: true,
  'aria-pressed': props.active,
}))<{ active?: boolean }>`
  && {
    border-radius: 3px;
    height: 1.75rem;
    padding: 0;

    @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
      font-size: 1rem;
      height: 2rem;
    }
  }
`;

export default ToggleButton;
